{
  "add": "Thêm",
  "age": {
    "range": {
      "ADULT": "Người lớn",
      "BABY": "Trẻ sơ sinh",
      "CHILD": "Trẻ em",
      "SENIOR": "Người cao tuổi",
      "TURNING_SENIOR": "Sắp cao tuổi",
      "YOUNG_ADULT": "Thanh niên",
      "YOUTH": "Thiếu niên"
    },
    "unknown": "Không rõ độ tuổi",
    "years": "{{ years }} tuổi"
  },
  "ages": {
    "ADULT": "(21-63) Người lớn",
    "BABY": "(0-1) Trẻ sơ sinh",
    "CHILD": "(1-5) Trẻ em",
    "SENIOR": "(65+) Người cao tuổi",
    "TURNING_SENIOR": "(64) Sắp cao tuổi",
    "YOUNG_ADULT": "(19-20) Thanh niên",
    "YOUTH": "(6-18) Thiếu niên"
  },
  "back": "Quay lại",
  "cancel": "Hủy",
  "childCaregiverStatus": {
    "CAREGIVER": "Có",
    "NOT_CAREGIVER": "Không"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Tình trạng nhập cư hợp lệ (thẻ xanh, v.v.)",
    "NOT_ANSWERED": "Ưu tiên không trả lời",
    "US_CITIZEN": "Công dân Hoa Kỳ",
    "US_NATIONAL": "Công dân quốc tịch Hoa Kỳ"
  },
  "clear": "Xóa",
  "clearAddress": "Xóa địa chỉ",
  "clearFilters": "Xóa bộ lọc",
  "clinic": "Phòng khám",
  "close": "Đóng",
  "continue": "Tiếp tục",
  "dateOfBirth": "Ngày sinh",
  "datePicker": {
    "placeholder": "Chọn một ngày",
    "required": "Vui lòng chọn một ngày."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} ngày",
    "daysWithCount_other": "{{count}} ngày",
    "monthsWithCount_one": "{{count}} tháng",
    "monthsWithCount_other": "{{count}} tháng",
    "yearsWithCount_one": "{{count}} năm",
    "yearsWithCount_other": "{{count}} năm"
  },
  "day": "Ngày",
  "delete": "Xóa",
  "discardFormChangesDialog": {
    "cancelButton": "Quay lại chỉnh sửa",
    "confirmButton": "Vẫn rời khỏi",
    "creating": "đang tạo",
    "description": "Có những thay đổi chưa được lưu cho {{entity}} mà bạn {{action}}. Nếu rời khỏi trang này, bạn sẽ mất các thông tin đã nhập.",
    "entity": "thông tin",
    "title": "Bạn có chắc chắn muốn rời khỏi?",
    "updating": "đang chỉnh sửa"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Bằng chứng nhập cư",
    "PROOF_OF_EXEMPTION": "Bằng chứng miễn trừ",
    "PROOF_OF_EXPENSE": "Bằng chứng chi phí",
    "PROOF_OF_IDENTITY": "Bằng chứng danh tính",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Bằng chứng thu nhập và việc làm",
    "PROOF_OF_INSURANCE": "Bằng chứng bảo hiểm từ chủ lao động hoặc bảo hiểm khác",
    "PROOF_OF_RESIDENCE": "Bằng chứng cư trú",
    "PROOF_OF_WORK": "Bằng chứng công việc",
    "SOCIAL_SECURITY_NUMBER": "Số An sinh Xã hội"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Tiền cấp dưỡng đã trả",
    "AUTHORIZED_EMPLOYMENT_ID": "Thẻ nhận dạng quyền làm việc",
    "BANK_STATEMENTS": "Sao kê ngân hàng",
    "BIRTH_CERTIFICATE": "Giấy khai sinh",
    "CHILDCARE": "Chăm sóc trẻ em",
    "CHILDS_BIRTH_CERTIFICATE": "Giấy khai sinh của trẻ",
    "CHILDS_PASSPORT": "Hộ chiếu của trẻ",
    "COURT_ORDERED_STATEMENTS": "Văn bản lệnh của tòa án",
    "DOCTORS_NOTE": "Giấy xác nhận của bác sĩ",
    "DRIVERS_LICENSE": "Bằng lái xe",
    "EXPENSE_OTHER": "Khác",
    "FOSTER_CARE_VERIFICATION_LETTER": "Thư xác nhận chăm sóc nuôi dưỡng",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Giấy tờ giám hộ hoặc quyền nuôi con",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Giấy tờ nhập cư và phê duyệt",
    "INSURANCE_CARD": "Thẻ bảo hiểm",
    "INSURANCE_CARRIER_INFO": "Thông tin hãng bảo hiểm (tên và địa chỉ)",
    "INSURANCE_POLICY_NUMBER": "Số hợp đồng bảo hiểm",
    "IRA_CONTRIBUTIONS": "Đóng góp IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Thư xác nhận từ chủ lao động",
    "MEDICAL_EXPENSE": "Chi phí y tế",
    "MEDICARE_CARD": "Thẻ Medicare",
    "MORTGAGE_STATEMENT": "Sao kê thế chấp nhà",
    "MOVING_EXPENSES": "Chi phí chuyển nhà",
    "PASSPORT": "Hộ chiếu",
    "PAY_STUBS": "Cuống lương (30 ngày gần nhất)",
    "PENSION_STATEMENTS": "Sao kê lương hưu",
    "PROPERTY_TAX_BILL": "Hóa đơn thuế tài sản",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Giấy tờ phóng thích hoặc ra trại",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Biên lai tiền thuê hoặc Hợp đồng thuê nhà",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Xác nhận nhập học hoặc bảng điểm",
    "SIGNED_LETTER": "Thư có chữ ký",
    "SIGNED_TIMESHEETS": "Bảng chấm công có chữ ký",
    "SNAP_TANF_VERIFICATION_LETTER": "Thư xác nhận SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "Thẻ An sinh Xã hội",
    "SSA_STATEMENTS": "Sao kê SSA",
    "SSDI_STATEMENTS": "Sao kê SSDI",
    "STATE_ID": "Thẻ căn cước tiểu bang (ID)",
    "STUDENT_LOANS": "Khoản vay sinh viên",
    "TAX_RETURN": "Tờ khai thuế (mới nhất)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Giấy chứng nhận ghi danh đào tạo hoặc học nghề",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Thư xác nhận ghi danh chương trình điều trị",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Thẻ hoặc thư ghi danh bộ lạc",
    "TUITION_FEES": "Học phí",
    "UNEMPLOYMENT_STATEMENTS": "Sao kê trợ cấp thất nghiệp",
    "USCIS_ID": "Mã số USCIS (dành cho người không phải công dân)",
    "UTILITY_BILL": "Hóa đơn tiện ích (điện, nước, v.v.)",
    "VA_DISABILITY_RATING_LETTER": "Thư xếp hạng khuyết tật của VA",
    "W2_FORMS": "Mẫu W-2",
    "descriptions": {
      "ALIMONY_PAID": "Thỏa thuận ly hôn hoặc ly thân",
      "AUTHORIZED_EMPLOYMENT_ID": "Giấy tờ cấp quyền làm việc từ USCIS",
      "BANK_STATEMENTS": "Sao kê tài khoản thanh toán hoặc tiết kiệm trong 30 ngày qua",
      "BIRTH_CERTIFICATE": "Giấy khai sinh Hoa Kỳ có tên và ngày sinh của bạn",
      "CHILDCARE": "Sao kê ngân hàng, biên lai hoặc thư từ nhà cung cấp dịch vụ chăm sóc trẻ của bạn",
      "CHILDS_BIRTH_CERTIFICATE": "Giấy khai sinh có tên và ngày sinh của con bạn",
      "CHILDS_PASSPORT": "Hộ chiếu Hoa Kỳ có tên và ngày sinh của con bạn",
      "COURT_ORDERED_STATEMENTS": "Lệnh của tòa án về hỗ trợ nuôi con, cấp dưỡng hoặc bồi thường tai nạn lao động",
      "DOCTORS_NOTE": "Thư của bác sĩ mô tả tình trạng bệnh lý, khuyết tật hoặc thai kỳ là cơ sở cho trường hợp miễn trừ này",
      "DRIVERS_LICENSE": "Bằng lái xe hiện tại có tên, ngày sinh và địa chỉ của bạn",
      "EXEMPTION_SSA_STATEMENTS": "Thư cho thấy tiền trợ cấp An sinh Xã hội của người mà bạn chăm sóc",
      "EXEMPTION_SSDI_STATEMENTS": "Thư cho thấy tiền trợ cấp khuyết tật của người mà bạn chăm sóc",
      "EXPENSE_OTHER": "Lệnh của tòa án hoặc thỏa thuận bằng văn bản cho thấy số tiền thanh toán",
      "FOSTER_CARE_VERIFICATION_LETTER": "Thư từ cơ quan chăm sóc nuôi dưỡng của tiểu bang xác nhận tình trạng và tuổi của bạn",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Lệnh của tòa án hoặc giấy tờ quyền nuôi con cho thấy bạn là người chăm sóc hợp pháp của trẻ",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Giấy phép làm việc, thị thực (visa) hoặc giấy tờ USCIS khác cho thấy tình trạng của bạn",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Giấy khai sinh có tên và ngày sinh của bạn",
      "IMMIGRATION_PASSPORT": "Hộ chiếu có tên và ngày sinh của bạn",
      "INSURANCE_CARD": "Ảnh mặt trước và mặt sau của thẻ có tên hãng và số hợp đồng",
      "INSURANCE_CARRIER_INFO": "Giấy tờ có tên và địa chỉ của công ty bảo hiểm",
      "INSURANCE_POLICY_NUMBER": "Giấy tờ cho thấy số hợp đồng bảo hiểm hoặc mã số thành viên của bạn",
      "IRA_CONTRIBUTIONS": "Sao kê từ ngân hàng hoặc nhà cung cấp IRA của bạn",
      "I_20": "Biểu mẫu giấy từ trường của bạn cho thấy bạn có thể học tập tại Hoa Kỳ",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Thư xác nhận công việc và mức lương của bạn",
      "MEDICAL_EXPENSE": "Sao kê ngân hàng, hóa đơn hoặc biên lai từ bác sĩ, bệnh viện hoặc nhà thuốc của bạn",
      "MEDICARE_CARD": "Thẻ Medicare cho thấy bạn đã ghi danh Medicare Phần A và/hoặc Phần B",
      "MORTGAGE_STATEMENT": "Sao kê thế chấp trong vòng 60 ngày qua có địa chỉ của bạn",
      "MOVING_EXPENSES": "Biên lai chuyển nhà và thư từ chủ lao động của bạn",
      "PASSPORT": "Hộ chiếu Hoa Kỳ có tên và ngày sinh của bạn",
      "PAY_STUBS": "Cuống lương từ 30 ngày qua cho thấy lương gộp và tên chủ lao động",
      "PENSION_STATEMENTS": "Văn bản cho thấy số tiền lương hưu hàng tháng của bạn",
      "PROPERTY_TAX_BILL": "Hóa đơn thuế tài sản có địa chỉ của bạn",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Giấy tờ cho thấy ngày bạn được thả khỏi trại giam hoặc nhà tù",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Biên lai thu tiền thuê hoặc hợp đồng thuê cho thấy địa chỉ hiện tại",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Thư hoặc bảng điểm cho thấy bạn đang theo học ít nhất bán thời gian",
      "SIGNED_LETTER": "Thư xác nhận việc đào tạo, đi học, học nghề hoặc phục vụ cộng đồng",
      "SIGNED_TIMESHEETS": "Bảng chấm công có chữ ký của chủ lao động hoặc người giám sát, cho thấy số giờ đã làm việc",
      "SNAP_TANF_VERIFICATION_LETTER": "Thư từ văn phòng SNAP hoặc TANF xác nhận bạn đang đáp ứng yêu cầu công việc của họ",
      "SOCIAL_SECURITY_CARD": "Thẻ An Sinh Xã Hội gồm tên và 9 chữ số của bạn",
      "SSA_STATEMENTS": "Thư cho thấy tiền trợ cấp An sinh Xã hội hàng tháng của bạn",
      "SSDI_STATEMENTS": "Thư cho thấy tiền trợ cấp khuyết tật hàng tháng của bạn",
      "STATE_ID": "Thẻ căn cước tiểu bang hiện tại có tên, ngày sinh và địa chỉ của bạn",
      "STUDENT_LOANS": "Sao kê từ ngân hàng hoặc đơn vị quản lý khoản vay của bạn",
      "TAX_RETURN": "Bộ hồ sơ khai thuế đầy đủ của năm gần nhất",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Giấy chứng nhận hoặc thư cho thấy bạn đã ghi danh vào chương trình đào tạo hoặc học nghề",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Thư xác nhận bạn đã ghi danh vào chương trình điều trị cai nghiện ma túy hoặc rượu",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Thẻ ID bộ lạc hoặc thư xác nhận tư cách thành viên của bạn",
      "TUITION_FEES": "Biên lai hoặc hóa đơn từ trường của bạn",
      "UNEMPLOYMENT_STATEMENTS": "Thư cho thấy tiền trợ cấp thất nghiệp hàng tuần hoặc hàng tháng của bạn",
      "USCIS_ID": "Thẻ xanh, giấy phép làm việc hoặc giấy chứng nhận quốc tịch",
      "UTILITY_BILL": "Hóa đơn trong 60 ngày qua (điện, gas, nước hoặc điện thoại) có địa chỉ của bạn",
      "VA_DISABILITY_RATING_LETTER": "Thư của VA cho thấy mức xếp hạng khuyết tật 100% của bạn",
      "W2_FORMS": "Mẫu W-2 gần nhất cho thấy chủ lao động và tiền lương của bạn"
    }
  },
  "documents": {
    "choosePhoto": "Chọn ảnh",
    "takePhoto": "Chụp ảnh"
  },
  "done": "Xong",
  "edit": "Chỉnh sửa",
  "email": "Email",
  "error": "Lỗi",
  "errorFallback": {
    "description": "Gặp sự cố khi tải trang này.",
    "resetCta": "Thử lại",
    "title": "Đã có lỗi xảy ra."
  },
  "errors": {
    "appleSsoNotSupported": "Đăng nhập bằng Apple không khả dụng. Vui lòng thử cách khác.",
    "emptyHomeAddress": "Vui lòng nhập địa chỉ nhà, hoặc chọn \"Không có địa chỉ nhà cố định\".",
    "emptyMailingAddress": "Vui lòng nhập địa chỉ nhận thư.",
    "googleSsoNotSupported": "Đăng nhập bằng Google không khả dụng. Vui lòng thử cách khác.",
    "invalidEmail": "Vui lòng nhập email hợp lệ (ví dụ: name@example.com).",
    "selectValidOption": "Vui lòng chọn một tùy chọn hợp lệ.",
    "unableToCreateApplications": "Chúng tôi không thể gửi hồ sơ của bạn. Kiểm tra mạng và thử lại.",
    "unauthenticated": "Vui lòng đăng nhập để tiếp tục.",
    "unauthorized": "Bạn không có quyền đăng nhập. Nếu là lỗi, hãy gửi email đến support@pointcare.com.",
    "unknown": "Đã có lỗi xảy ra. Vui lòng thử lại."
  },
  "exit": "Thoát",
  "female": "Nữ",
  "filesWithCount_one": "{{count}} tệp",
  "filesWithCount_other": "{{count}} tệp",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Bảo hiểm y tế qua công việc (do chủ lao động tài trợ)",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Loại khác",
    "PRIVATE": "Bảo hiểm tư nhân hoặc Marketplace ACA",
    "TRICARE": "TRICARE (bảo hiểm y tế quân đội)",
    "VA": "Chương trình chăm sóc sức khỏe VA"
  },
  "home": "Trang chủ",
  "householdMember": "Thành viên gia đình",
  "listConnector": " và ",
  "listSeparator": ", ",
  "loading": "Đang tải...",
  "login": {
    "checkYourEmail": "Kiểm tra email {{email}} để nhận liên kết đăng nhập.",
    "placeholder": "ten@vidu.com",
    "sendEmail": "Gửi email"
  },
  "longDateFormat": "Ngày D tháng MMMM, YYYY",
  "male": "Nam",
  "maritalStatus": {
    "COMMON_LAW": "Hôn nhân thực tế (Common Law)",
    "DIVORCED": "Đã ly hôn",
    "MARRIED": "Đã kết hôn",
    "NEVER_MARRIED": "Chưa từng kết hôn",
    "REGISTERED_DOMESTIC_PARTNER": "Bạn đời có đăng ký",
    "SEPARATED": "Ly thân",
    "WIDOWED": "Góa"
  },
  "marketplace": "Marketplace ACA",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Phần C)",
    "NOT_SURE": "Không chắc",
    "ORIGINAL": "Phần A và B (Original)"
  },
  "member_one": "{{count}} thành viên",
  "member_other": "{{count}} thành viên",
  "month": "Tháng",
  "next": "Tiếp theo",
  "no": "Không",
  "noResults": "Không tìm thấy kết quả",
  "noneOfTheAbove": "Không có mục nào ở trên",
  "ok": "OK",
  "open": "Mở",
  "or": "hoặc",
  "pagination": {
    "goToFirstPage": "Đến trang đầu",
    "goToLastPage": "Đến trang cuối",
    "goToNextPage": "Đến trang sau",
    "goToPreviousPage": "Đến trang trước",
    "morePages": "Thêm trang",
    "pagination": "Phân trang",
    "rowsPerPage": "Số hàng mỗi trang",
    "rowsResults": "{{from}} đến {{to}} trong tổng số {{total}} kết quả",
    "showingPrefix": "Đang hiển thị "
  },
  "payFrequency": {
    "ANNUALLY": "Hàng năm",
    "BI_WEEKLY": "Mỗi 2 tuần",
    "MONTHLY": "Hàng tháng",
    "WEEKLY": "Hàng tuần"
  },
  "pdfViewer": {
    "loading": "Đang tải tài liệu..."
  },
  "program_one": "{{count}} chương trình",
  "program_other": "{{count}} chương trình",
  "progressIndicator": "Tiến độ: Hoàn thành {{progress}} trên {{total}}",
  "relationships": {
    "CHILD": "Con",
    "FOSTER_CHILD": "Con nuôi/Con tạm dưỡng",
    "GRANDCHILD": "Cháu nội/ngoại",
    "GRANDPARENT": "Ông/Bà",
    "OTHER": "Khác",
    "PARENT": "Cha/Mẹ",
    "PARTNER": "Bạn đời",
    "SIBLING": "Anh chị em",
    "SPOUSE": "Vợ/Chồng",
    "STEPCHILD": "Con riêng"
  },
  "required": "Ô này là bắt buộc.",
  "returnToDashboard": "Quay lại Bảng điều khiển",
  "save": "Lưu",
  "saveChanges": "Lưu thay đổi",
  "share": "Chia sẻ",
  "sidebar": {
    "title": "Thanh bên",
    "toggle": "Bật/tắt thanh bên"
  },
  "signOut": "Đăng xuất",
  "skip": "Bỏ qua",
  "stepIndicator": "Bước {{currentStep}} trên {{totalSteps}}",
  "submit": "Gửi",
  "tabs": {
    "home": "Trang chủ"
  },
  "taxFilingStatus": {
    "HEAD": "Chủ hộ",
    "JOINTLY": "Kết hôn, khai thuế chung",
    "NON_FILER": "Không khai thuế",
    "SEPARATELY": "Kết hôn, khai thuế riêng",
    "SINGLE": "Độc thân",
    "WIDOWER": "Vợ/Chồng góa có con phụ thuộc đủ điều kiện"
  },
  "theme": "Giao diện",
  "time": {
    "am": "Sáng",
    "pm": "Chiều"
  },
  "undo": "Hoàn tác",
  "unknown": "Không xác định",
  "uploadButton": {
    "title": "Tải tệp lên hoặc Chụp ảnh"
  },
  "validation": {
    "atLeastOneOption": "Vui lòng chọn ít nhất một lựa chọn.",
    "genericError": "Không thành công. Vui lòng thử lại.",
    "invalidCode": "Mã không khớp. Vui lòng kiểm tra lại hoặc yêu cầu mã mới.",
    "invalidEmail": "Vui lòng nhập email hợp lệ (ví dụ: name@example.com).",
    "invalidNumber": "Vui lòng nhập một số hợp lệ.",
    "invalidPassword": "Mật khẩu không đúng. Vui lòng thử lại.",
    "invalidPhone": "Vui lòng nhập số điện thoại gồm 10 chữ số.",
    "invalidSsn": "Số An sinh Xã hội chỉ được bao gồm các chữ số (không có dấu gạch ngang hoặc khoảng trắng).",
    "invalidSsnFormat": "Số An sinh Xã hội này không hợp lệ. Vui lòng kiểm tra lại và thử lại.",
    "invalidSsnLength": "Vui lòng nhập số An sinh Xã hội gồm 9 chữ số.",
    "numberMustBeNonNegative": "Vui lòng nhập một số từ 0 trở lên.",
    "passwordMismatch": "Mật khẩu không khớp.",
    "requiredField": "Vui lòng điền vào ô này.",
    "requiredFields": "Vui lòng điền vào tất cả các ô bắt buộc.",
    "requiredNonNegative": "Vui lòng nhập một số từ 0 trở lên.",
    "requiredPassword": "Vui lòng nhập mật khẩu của bạn.",
    "unknown": "Đã có lỗi xảy ra. Vui lòng thử lại."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Nhập email của bạn để hoàn thành đăng nhập",
    "verify": "Xác minh",
    "verifyError": "Chúng tôi không thể xác nhận liên kết đăng nhập của bạn. Có thể nó đã hết hạn. Vui lòng yêu cầu liên kết mới."
  },
  "whoApplies": "Thông tin này áp dụng cho ai?",
  "whoIsApplying": "Ai đang nộp đơn?",
  "year": "Năm",
  "yes": "Có",
  "zoom": "Thu phóng",
  "zoomIn": "Phóng to",
  "zoomOut": "Thu nhỏ",
  "zoomReset": "Đặt lại độ thu phóng"
}
